import { render, staticRenderFns } from "./FieldDateTime.vue?vue&type=template&id=38c13b6c"
import script from "./FieldDateTime.vue?vue&type=script&lang=js"
export * from "./FieldDateTime.vue?vue&type=script&lang=js"
import style0 from "./FieldDateTime.vue?vue&type=style&index=0&id=38c13b6c&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QDate from 'quasar/src/components/date/QDate.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTime from 'quasar/src/components/time/QTime.js';
import QField from 'quasar/src/components/field/QField.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QIcon,QPopupProxy,QDate,QBtn,QTime,QField});qInstall(component, 'directives', {ClosePopup});
